import { render, staticRenderFns } from "./send_prices.vue?vue&type=template&id=0ff1c92a&"
import script from "./send_prices.vue?vue&type=script&lang=js&"
export * from "./send_prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports